import type { Locale } from "../../../types";
import type { Ambles, AmbleContent } from "../../../content/ambles";
import { LOCALE_EN_GB } from "../../../constants/constants";

export type AmbleLookupParams = {
  ambleName: string;
  site: string;
  locale: Locale;
  ambles: Ambles;
};

/**
 * Looks up amble with priority: site → locale
 */
export function getAmble(params: AmbleLookupParams): AmbleContent | undefined {
  const { ambleName, site, locale, ambles } = params;

  const siteAmble = ambles.siteAmbles[site]?.[ambleName];
  if (siteAmble) return siteAmble;

  const localeAmbles =
    locale === LOCALE_EN_GB
      ? ambles.simplybusinessUkAmbles
      : ambles.simplybusinessUsAmbles;

  return localeAmbles[ambleName];
}
